class CryptoService {
    static ALGORITHM = process.env.REACT_APP_ENCRYTION_METHOD;
    static HASH = process.env.REACT_APP_ENCRYTION_HASH;
    static KEY_SIZE = process.env.REACT_APP_ENCRYTION_KEY_SIZE;
    static ITERATION_COUNT = process.env.REACT_APP_ENCRYTION_ITERATION_COUNT;    
    static textEncoder = new TextEncoder();
    static textDecoder = new TextDecoder();

    static async generateKeyMaterial(password) {
        return window.crypto.subtle.importKey(
            "raw",
            CryptoService.textEncoder.encode(password),
            { name: "PBKDF2" },
            false,
            ["deriveBits", "deriveKey"]
        );
    }

    static async generateKey(keyMaterial, salt) {
        const algorithm = CryptoService.ALGORITHM;
        const hash = CryptoService.HASH;
        const iterationCount = CryptoService.ITERATION_COUNT;
        const keySize = CryptoService.KEY_SIZE;

        return window.crypto.subtle.deriveKey(
            {
                name: "PBKDF2",
                salt,
                iterations: iterationCount,
                hash: hash
            },
            keyMaterial,
            { 
                name: algorithm,
                length: keySize 
            },
            true,
            ["encrypt", "decrypt"]
        );
    }

    static async encrypt(plaintext, password) {
        const data = CryptoService.textEncoder.encode(plaintext);
        const salt = window.crypto.getRandomValues(new Uint8Array(process.env.REACT_APP_ENCRYTION_SALT));
        const keyMaterial = await this.generateKeyMaterial(password);
        const key = await this.generateKey(keyMaterial, salt);
        const algorithm = CryptoService.ALGORITHM;
        const iv = window.crypto.getRandomValues(new Uint8Array(process.env.REACT_APP_ENCRYTION_IV));
        const encryptedData = await window.crypto.subtle.encrypt(
            {
                name: algorithm,
                iv
            },
            key,
            data
        );

        const ciphertextBase64 = btoa(CryptoService.arrayBufferToBase64(encryptedData));
        const ivBase64 =  btoa(CryptoService.arrayBufferToBase64(iv));
        const saltBase64 =  btoa(CryptoService.arrayBufferToBase64(salt));

        return btoa(ciphertextBase64 + ":" + ivBase64 + ":" + saltBase64);
    }

    static async decrypt(encryptedData, password) {
        const [ciphertextStr, ivStr, saltStr] = atob(encryptedData).split(":");
        const ciphertext = Uint8Array.from(atob(ciphertextStr), c => c.charCodeAt(0));
        const iv = Uint8Array.from(atob(ivStr), c => c.charCodeAt(0));
        const salt = Uint8Array.from(atob(saltStr), c => c.charCodeAt(0));
        const algorithm = CryptoService.ALGORITHM;
        const keyMaterial = await this.generateKeyMaterial(password);
        const key = await this.generateKey(keyMaterial, salt)
        console.log("OKKK1")
        const decryptedData = await window.crypto.subtle.decrypt(
            {
                name: algorithm,
                iv
            },
            key,
            ciphertext
        );
        console.log("OKKK2")
        return CryptoService.textDecoder.decode(decryptedData);
    }

    static arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.length;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return binary;
    }
}

export default CryptoService;